export default __webpack_public_path__ + "static/media/Soybean.ab7aaf81.jpg";